import {PriorityIcon} from '@priority-software/priority-style-react';
export const supportedPics = ['jpg', 'jpeg', 'gif', 'tif', 'tiff', 'png', 'bmp', 'jpe', 'ico'];

export const extentionIcons = {
    doc: PriorityIcon.doc,
    dot: PriorityIcon.doc,
    rtf: PriorityIcon.doc,
    docx: PriorityIcon.doc,
    dotx: PriorityIcon.doc,
    xls: PriorityIcon.excel,
    xlsx: PriorityIcon.excel,
    xlt: PriorityIcon.excel,
    ppt: PriorityIcon.ppt,
    pptx: PriorityIcon.ppt,
    pps: PriorityIcon.ppt,
    ppsx: PriorityIcon.ppt,
    txt: PriorityIcon.txt,
    msg: PriorityIcon.msg,
    pdf: PriorityIcon.pdf
};
